import "../../Styles/landing/Balls.styles.scss"

const Balls = () => {
    return (
        <>
            <div className="dec1"></div>
            <div className="dec2"></div>
        </>
    );
}


export default Balls;